// PoW solver using an inline Web Worker.
// The worker embeds its own synchronous SHA-256 so the main thread stays free.

/* eslint-disable no-restricted-globals */
var POW_WORKER_CODE =
  "'use strict';\n" +
  'var K=new Uint32Array([' +
  '0x428a2f98,0x71374491,0xb5c0fbcf,0xe9b5dba5,' +
  '0x3956c25b,0x59f111f1,0x923f82a4,0xab1c5ed5,' +
  '0xd807aa98,0x12835b01,0x243185be,0x550c7dc3,' +
  '0x72be5d74,0x80deb1fe,0x9bdc06a7,0xc19bf174,' +
  '0xe49b69c1,0xefbe4786,0x0fc19dc6,0x240ca1cc,' +
  '0x2de92c6f,0x4a7484aa,0x5cb0a9dc,0x76f988da,' +
  '0x983e5152,0xa831c66d,0xb00327c8,0xbf597fc7,' +
  '0xc6e00bf3,0xd5a79147,0x06ca6351,0x14292967,' +
  '0x27b70a85,0x2e1b2138,0x4d2c6dfc,0x53380d13,' +
  '0x650a7354,0x766a0abb,0x81c2c92e,0x92722c85,' +
  '0xa2bfe8a1,0xa81a664b,0xc24b8b70,0xc76c51a3,' +
  '0xd192e819,0xd6990624,0xf40e3585,0x106aa070,' +
  '0x19a4c116,0x1e376c08,0x2748774c,0x34b0bcb5,' +
  '0x391c0cb3,0x4ed8aa4a,0x5b9cca4f,0x682e6ff3,' +
  '0x748f82ee,0x78a5636f,0x84c87814,0x8cc70208,' +
  '0x90befffa,0xa4506ceb,0xbef9a3f7,0xc67178f2]);\n' +
  'var H0=new Uint32Array([' +
  '0x6a09e667,0xbb67ae85,0x3c6ef372,0xa54ff53a,' +
  '0x510e527f,0x9b05688c,0x1f83d9ab,0x5be0cd19]);\n' +
  'var enc=new TextEncoder();\n' +
  'function rotr(x,n){return((x>>>n)|(x<<(32-n)))>>>0;}\n' +
  'function sha256(str){\n' +
  '  var b=enc.encode(str),bl=b.length*8;\n' +
  '  var pl=Math.ceil((b.length+9)/64)*64;\n' +
  '  var p=new Uint8Array(pl);p.set(b);p[b.length]=0x80;\n' +
  '  var v=new DataView(p.buffer);v.setUint32(pl-4,bl,false);\n' +
  '  var h=new Uint32Array(H0),w=new Uint32Array(64);\n' +
  '  for(var o=0;o<pl;o+=64){\n' +
  '    for(var i=0;i<16;i++)w[i]=v.getUint32(o+i*4,false);\n' +
  '    for(var i=16;i<64;i++){\n' +
  '      var s0=(rotr(w[i-15],7)^rotr(w[i-15],18)^(w[i-15]>>>3))>>>0;\n' +
  '      var s1=(rotr(w[i-2],17)^rotr(w[i-2],19)^(w[i-2]>>>10))>>>0;\n' +
  '      w[i]=(w[i-16]+s0+w[i-7]+s1)>>>0;}\n' +
  '    var a=h[0],b2=h[1],c=h[2],d=h[3];\n' +
  '    var e=h[4],f=h[5],g=h[6],hh=h[7];\n' +
  '    for(var i=0;i<64;i++){\n' +
  '      var S1=(rotr(e,6)^rotr(e,11)^rotr(e,25))>>>0;\n' +
  '      var ch=((e&f)^(~e&g))>>>0;\n' +
  '      var t1=(hh+S1+ch+K[i]+w[i])>>>0;\n' +
  '      var S0=(rotr(a,2)^rotr(a,13)^rotr(a,22))>>>0;\n' +
  '      var mj=((a&b2)^(a&c)^(b2&c))>>>0;\n' +
  '      var t2=(S0+mj)>>>0;\n' +
  '      hh=g;g=f;f=e;e=(d+t1)>>>0;d=c;c=b2;b2=a;a=(t1+t2)>>>0;}\n' +
  '    h[0]=(h[0]+a)>>>0;h[1]=(h[1]+b2)>>>0;\n' +
  '    h[2]=(h[2]+c)>>>0;h[3]=(h[3]+d)>>>0;\n' +
  '    h[4]=(h[4]+e)>>>0;h[5]=(h[5]+f)>>>0;\n' +
  '    h[6]=(h[6]+g)>>>0;h[7]=(h[7]+hh)>>>0;}\n' +
  '  var r=new Uint8Array(32),rv=new DataView(r.buffer);\n' +
  '  for(var i=0;i<8;i++)rv.setUint32(i*4,h[i],false);\n' +
  '  return r;}\n' +
  'function hasLZ(hash,bits){\n' +
  '  var rem=bits;\n' +
  '  for(var i=0;i<hash.length&&rem>0;i++){\n' +
  '    if(rem>=8){if(hash[i]!==0)return false;rem-=8;}\n' +
  '    else{var m=(0xff<<(8-rem))&0xff;if((hash[i]&m)!==0)return false;rem=0;}}\n' +
  '  return rem<=0;}\n' +
  'self.onmessage=function(ev){\n' +
  '  var d=ev.data,prefix=d.nonce+":"+d.normalizedEmail+":";\n' +
  '  var start=Date.now(),deadline=start+d.timeoutMs,counter=0;\n' +
  '  while(true){\n' +
  '    var hash=sha256(prefix+counter);\n' +
  '    if(hasLZ(hash,d.difficultyBits)){\n' +
  '      self.postMessage({type:"solved",counter:counter,elapsed:Date.now()-start});return;}\n' +
  '    counter++;\n' +
  '    if(counter%5000===0&&Date.now()>=deadline)break;}\n' +
  '  self.postMessage({type:"timeout",counter:counter,elapsed:Date.now()-start});};\n';
/* eslint-enable no-restricted-globals */

export function solveChallenge({
  nonce,
  normalizedEmail,
  difficultyBits,
  timeoutMs,
}) {
  return new Promise(function(resolve, reject) {
    var worker;
    try {
      var blob = new Blob([POW_WORKER_CODE], {
        type: 'application/javascript',
      });
      var url = URL.createObjectURL(blob);
      worker = new Worker(url);
      URL.revokeObjectURL(url);
    } catch (err) {
      reject(new Error('Failed to create PoW worker: ' + err.message));
      return;
    }

    var cleanup = function() {
      if (worker) {
        worker.terminate();
        worker = null;
      }
    };

    worker.onmessage = function(e) {
      var data = e.data;
      cleanup();
      if (data.type === 'solved') {
        resolve({ counter: data.counter, elapsed: data.elapsed });
      } else if (data.type === 'timeout') {
        reject(new Error('PoW solving timed out'));
      } else {
        reject(new Error('Unknown worker response'));
      }
    };

    worker.onerror = function(err) {
      cleanup();
      reject(new Error('PoW worker error: ' + (err.message || 'unknown')));
    };

    worker.postMessage({
      nonce: nonce,
      normalizedEmail: normalizedEmail,
      difficultyBits: difficultyBits,
      timeoutMs: timeoutMs,
    });
  });
}
